import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)

        // UI
        this.$el = this.el
        this.$number = this.$('number')[0]
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()

        if (window.isFontsLoaded) {
            this.onFontsLoaded()
        }
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    unbindEvents() {
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onFontsLoaded() {
        this.initNumber()
    }

    ///////////////
    // Methods
    ///////////////
    initNumber() {
        let allNumbersCharElement = ''

        const numberStr = this.$number.innerHTML
        const numbers = numberStr.split('');

        let numbersIndex = 0
        while (numbersIndex < numbers.length) {

            const number = numbers[numbersIndex].trim().length ? numbers[numbersIndex] : "&nbsp;"
            const numberTop = "<span class='u-number_char'>" + number + "</span>";
            const numberBottom = "<span class='u-number_char' aria-hidden='true'>" + number + "</span>";
            const newNumber = numberTop + numberBottom

            allNumbersCharElement += "<span class='u-number_char_wrapper || u-anim-numbers-scroll' style='--delay:"+ numbersIndex +"'>" + newNumber + "</span>"

            numbersIndex++
        }

        this.$number.innerHTML = allNumbersCharElement
    }
}